import React from 'react';
import PropTypes from 'prop-types';
import ViewColumnOutlinedIcon from '@material-ui/icons/ViewColumnOutlined';

import DecisionTool from './DecisionTool';

import { getString } from '../../../../helpers/stringHelpers';

const stringsComponent = 'fencingApplications';

class FenceDecisionTool extends React.Component {
	questions = [
		{
			key: 'q1',
			title: getString(stringsComponent, 'QUESTION_ONE'),
			mutexQuestions: [],
			answers: [
				{
					key: 'yes',
					title: getString(stringsComponent, 'ANSWER_YES'),
					progressText: getString(
						stringsComponent,
						'QUESTION_ONE_ANSWER_ONE_PROGRESS'
					),
					nextQuestion: 'q2',
				},
				{
					key: 'no',
					title: getString(stringsComponent, 'ANSWER_NO'),
					progressText: getString(
						stringsComponent,
						'QUESTION_ONE_ANSWER_TWO_PROGRESS'
					),
					nextQuestion: 'q3',
				},
			],
		},
		{
			key: 'q2',
			mutexQuestions: ['q3'],
			title: getString(stringsComponent, 'QUESTION_TWO'),
			answers: [
				{
					key: 'yes',
					title: getString(stringsComponent, 'ANSWER_YES'),
					progressText: getString(
						stringsComponent,
						'QUESTION_TWO_ANSWER_ONE_PROGRESS'
					),
					nextQuestion: null,
				},
				{
					key: 'no',
					title: getString(stringsComponent, 'ANSWER_NO'),
					progressText: getString(
						stringsComponent,
						'QUESTION_TWO_ANSWER_TWO_PROGRESS'
					),
					nextQuestion: 'q4',
				},
			],
		},
		{
			key: 'q3',
			mutexQuestions: ['q2'],
			title: getString(stringsComponent, 'QUESTION_THREE'),
			answers: [
				{
					key: 'yes',
					title: getString(stringsComponent, 'ANSWER_YES'),
					progressText: getString(
						stringsComponent,
						'QUESTION_THREE_ANSWER_ONE_PROGRESS'
					),
					nextQuestion: null,
				},
				{
					key: 'no',
					title: getString(stringsComponent, 'ANSWER_NO'),
					progressText: getString(
						stringsComponent,
						'QUESTION_THREE_ANSWER_TWO_PROGRESS'
					),
					nextQuestion: null,
				},
			],
		},
		{
			key: 'q4',
			mutexQuestions: [],
			title: getString(stringsComponent, 'QUESTION_FOUR'),
			checkOptions: [
				{
					key: 'o1',
					title: getString(
						stringsComponent,
						'QUESTION_FOUR_OPTION_ONE'
					),
					mutexOptions: ['o6'],
				},
				{
					key: 'o2',
					title: getString(
						stringsComponent,
						'QUESTION_FOUR_OPTION_TWO'
					),
					mutexOptions: ['o6'],
				},
				{
					key: 'o3',
					title: getString(
						stringsComponent,
						'QUESTION_FOUR_OPTION_THREE'
					),
					mutexOptions: ['o6'],
				},
				{
					key: 'o4',
					title: getString(
						stringsComponent,
						'QUESTION_FOUR_OPTION_FOUR'
					),
					mutexOptions: ['o6'],
				},
				{
					key: 'o5',
					title: getString(
						stringsComponent,
						'QUESTION_FOUR_OPTION_FIVE'
					),
					mutexOptions: ['o6'],
				},
				{
					key: 'o6',
					title: getString(
						stringsComponent,
						'QUESTION_FOUR_OPTION_SIX'
					),
					mutexOptions: ['o1', 'o2', 'o3', 'o4', 'o5'],
				},
			],
			answers: [
				{
					key: 'yes',
					title: getString(stringsComponent, 'ANSWER_YES'),
					progressText: getString(
						stringsComponent,
						'QUESTION_FOUR_PROGRESS'
					),
					nextQuestion: null,
					hidden: true,
				},
			],
		},
	];

	results = [
		{
			body: getString(stringsComponent, 'RESULT_BODY_ONE'),
			answerCombinations: [['q1 no', 'q3 yes']],
		},
		{
			body: getString(stringsComponent, 'RESULT_BODY_TWO'),
			answerCombinations: [['q1 yes', 'q2 no', 'q4 yes']],
		},
		{
			body: getString(stringsComponent, 'RESULT_BODY_THREE'),
			answerCombinations: [['q1 no', 'q3 no']],
		},
		{
			body: getString(stringsComponent, 'RESULT_BODY_FOUR'),
			answerCombinations: [['q1 yes', 'q2 yes']],
		},
	];

	additionalCommentsDisplayConditions = [['q1 no', 'q3 no']];

	hideSubmitConditions = [['q1 yes', 'q2 yes']];

	showExclamationConditions = [['q1 yes', 'q2 yes']];

	constructor(props) {
		super(props);
	}

	render() {
		const { title } = this.props;

		return (
			<DecisionTool
				title={title}
				questions={this.questions}
				results={this.results}
				additionalCommentsDisplayConditions={
					this.additionalCommentsDisplayConditions
				}
				hideSubmitConditions={this.hideSubmitConditions}
				showExclamationConditions={this.showExclamationConditions}
				handleClose={() => this.props.handleClose()}
				handleSubmit={(data) => this.props.handleSubmit(data)}
				icon={ViewColumnOutlinedIcon}
			/>
		);
	}
}

FenceDecisionTool.propTypes = {
	title: PropTypes.string.isRequired,
	handleClose: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
};

export default FenceDecisionTool;
